import React from 'react'
import CommitteeBatchApprovalList from '../../../features/CommitteeApproval/components/CommitteeBatchApprovalList'

const CommitteeBatchApproval = () => {
  return (
    <>
    <CommitteeBatchApprovalList/>
    </>
  )
}

export default CommitteeBatchApproval
